export default __webpack_public_path__ + "static/media/dpd.efb8c8a1.svg";